import React from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { CreateAllData } from '@/apiError/apiCreate';
import { AntButton } from '@/common/ant-components/AntButton';

const ItemUploadButton = ({ refreshTable }) => {
  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      if (workbook.SheetNames.length !== 1) {
        message.error('The file must contain only one sheet.');
        return;
      }

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      submitData(parsedData);
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  const submitData = async (data) => {
    try {
      await CreateAllData.createItem('account/inventory/items/', data);
    } finally {
    }
  };

  return (
    <div>
      <Upload beforeUpload={handleFileUpload} showUploadList={false}>
        <AntButton icon={<UploadOutlined />}>Upload Excel</AntButton>
      </Upload>
    </div>
  );
};

export default ItemUploadButton;
